function onlyNumber(event: React.KeyboardEvent) {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
}

export const KeyPress = {
  onlyNumber,
};
